import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = ["gaigCard", "chubbCard"]

    connect() {
        super.connect()
    }

    selectGaig(event) {
        /* selectChubb action co-exists within a context where there are other interactable elements (buttons),
        and it always wins (this means that selectChubb always runs and the buttons' actions do not).
        To address that situation, we need to skip selectChubb so the other interactable elements properly work.
        */
        if (event.target.closest('button')) return

        /* Skip the reflex if GAIG is already selected. Re-rendering when already selected would reset
           the slider to the DB value, losing any unsaved position the user has chosen. */
        const gaigCard = document.getElementById('gaig-policy-card')
        if (gaigCard && gaigCard.dataset.gaigSelected === 'true') return

        event.preventDefault()
        this.selectCard("gaig")
    }

    selectChubb(event) {
        /* selectChubb action co-exists within a context where there are other interactable elements (buttons),
        and it always wins (this means that selectChubb always runs and the buttons' actions do not).
        To address that situation, we need to skip selectChubb so the other interactable elements properly work.
        */
        if (event.target.closest('button')) return

        event.preventDefault()
        this.selectCard("chubb")
    }

    autoSelectGaig() {
        this.selectCard("gaig")
    }

    /* Keeps clicks inside an interactive sub-section (e.g. the premium override inputs) from bubbling up to
       the card's select action, which would re-render the card and discard the user's in-progress input. */
    stopPropagation(event) {
        event.stopPropagation()
    }

    selectCard(carrier) {
        const quoteId = this.element.dataset.quoteId
        this.stimulate("QuoteFlowReflex#select_policy_card", quoteId, carrier)
    }
}

